import { toPrismicLang } from '../../helpers/i18n';
import error, { getErrorObject } from '../../helpers/error';
import { HTTP_CLIENT_ERROR_NOT_FOUND } from '../../helpers/http';

import { ERROR } from 'translations';

import { queryFirst } from '../../api/prismic';

export const LOAD_DOCUMENT_REQUEST = 'LOAD_DOCUMENT_REQUEST';
export const LOAD_DOCUMENT_SUCCESS = 'LOAD_DOCUMENT_SUCCESS';
export const LOAD_DOCUMENT_FAILURE = 'LOAD_DOCUMENT_FAILURE';

export const loadDocumentRequest = (lang, key) => ({
  type: LOAD_DOCUMENT_REQUEST,
  id: key,
  lang,
});

export const loadDocumentSuccess = (lang, key, document) => ({
  type: LOAD_DOCUMENT_SUCCESS,
  payload: document,
  id: key,
  lang,
});

export const loadDocumentFailure = (lang, key, error) => ({
  type: LOAD_DOCUMENT_FAILURE,
  payload: getErrorObject(error, ERROR.ERROR_LOADING_DOC, { key }),
  id: key,
  lang,
});

export const getDocument = (key, filters = [], opts = {}) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const locale = state.locale;
  const lang = toPrismicLang(locale);

  try {
    dispatch(loadDocumentRequest(locale, key));

    const document = await queryFirst(filters, { ...opts, lang });
    if (!document) {
      throw error(
        HTTP_CLIENT_ERROR_NOT_FOUND,
        'We could not find a document that matches this query.',
        'Not Found',
        { filters, opts }
      );
    }

    dispatch(loadDocumentSuccess(locale, key, document));
  } catch (error) {
    dispatch(loadDocumentFailure(locale, key, error));
  }
};
